import { CommanderAPI } from '../../api/CommanderAPI';
import { CommanderStatusAdapter } from './adapter/CommanderStatusAdapter';
import { CommanderStatusAPIService } from './CommanderStatusAPIService';
import convertPromiseToQueryReturnValue from '../../../../axios/convertPromiseToQueryReturnValue';
import _ from 'lodash';

export const CommanderStatusAPI = CommanderAPI.injectEndpoints({
  endpoints: (build) => ({
    getCommandersStatus: build.query({
      queryFn: (commanderIds: string[]) => {
        const response = new CommanderStatusAPIService()
          .getCommandersConnectionStatus(_.uniq(commanderIds))
          .then((data) =>
            CommanderStatusAdapter.setAll(
              CommanderStatusAdapter.getInitialState(),
              data
            )
          );
        return convertPromiseToQueryReturnValue(response);
      },
      providesTags: (result, error, commanderIds) =>
        commanderIds.map((id) => ({
          type: 'commander-status',
          id,
        })),
    }),
  }),
});
